module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0139.jpg?v=a59a8e0b";